module.exports = __webpack_public_path__ + "img/mail.bf7a9651.svg";